import { Auth } from "aws-amplify";
import React, { useState, useEffect } from "react";
import ButtonOAuth from "../../components/ButtonOAuth";
import Modal from "../../components/common/Modal";
import Formulario from "../../components/Formulario";
import Loading from "../../components/Loading/Loading";
import { CONSTANTES } from "../../utils/Constantes";
import { setLocalStorage } from "../../utils/LocalStorage";
import ChangePassword from "../ChangePassword";
import ReceiveCode from "../ReceiveCode";
import SendCodePassword from "../SendCodePassword";
import Alert from "../../components/common/Alert";
import proveedores_jpg from "../../assets/login.png";
import "./styles.scss";

const Login = ({ history }) => {
  const [isRequiredPassword, setIsRequiredPassword] = useState(false);
  const [isChangePassword, setIsChangePassword] = useState(false);
  const [isReceiveCode, setIsReceiveCode] = useState(false);

  const [responseAuth, setResponseAuth] = useState(null);
  const [dataFromSendCode, setDataFromSendCode] = useState(null);
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [messageModal, setMessageModal] = useState("");
  const [showAlert, setShowAlert] = useState({
    show: false,
    title: "",
    message: "",
    type: "",
  });

  const handleIsRequiredPassword = (value) => setIsRequiredPassword(value);
  const handleIsChangePassword = (value) => setIsChangePassword(value);
  const handleIsReceiveCode = (value) => setIsReceiveCode(value);
  const handleResponseAuth = (objAuth) => setResponseAuth(objAuth);
  const handleShowAlert = (obj) => {
    setShowAlert(obj);
    resetMessage(7);
  }
  const showLoading = (value) => setLoading(value);

  const redirect = (response) => {
    setLocalStorage("user", {
      username: response.username,
      clientId: response.pool.clientId,
    });
    console.log("LOGUEADO");
    history.push(CONSTANTES.RUTA.home);
  };

  const initMount = async () => {
    console.log("ENTRO login")
    try {
      const auxCurrentUser = await Auth.currentAuthenticatedUser();
      redirect(auxCurrentUser);
    } catch (error) {
      console.log("error login", error);
    }
  };

  useEffect(() => {
    initMount();
  }, []);

  const handleShowModal = (value) => {
    if (!value) setMessageModal("");
    setShowModal(value);
  };

  const handleCompleteNewPassword = async (newPassword) => {
    console.log("handleCompleteNewPassword", newPassword);
    showLoading(true);
    try {
      let responseNewPassword = await Auth.completeNewPassword(
        responseAuth,
        newPassword
      );
      console.log(
        "🚀 ~ file: index.jsx ~ line 30 ~ handleCompleteNewPassword ~ responseNewPassword",
        JSON.stringify(responseNewPassword)
      );
      showLoading(false);
      redirect(responseAuth);
    } catch (error) {
      console.error("ERROR SIGN:", error);
      showLoading(false);
      if ("UserNotConfirmedException" === error.code) {
        console.log(
          "🚀 ~ file: index.jsx ~ line 71 ~ initMount ~ error",
          error
        );
        console.log(
          "🚀 ~ file: index.jsx ~ line 71 ~ initMount ~ error",
          error
        );
        setMessageModal(
          "Usuario requiere confirmación del registro antes de Loguear"
        );
      } else if ("PasswordResetRequiredException" === error.code) {
        setMessageModal("Se requiere restablecer la contraseña");
      } else if ("NotAuthorizedException" === error.code) {
        setMessageModal("Contraseña inválida");
      } else if ("UserNotFoundException" === error.code) {
        setMessageModal("Usuario no existe");
      } else if ("InvalidPasswordException" === error.code) {
        setMessageModal("El formato de contraseña es inválido.");
      } else if (
        "UserLambdaValidationException" === error.code &&
        error.message.includes("REINTENTAR")
      ) {
        handleCompleteNewPassword(newPassword);
      } else {
        setMessageModal(
          "Ocurrió un error al autenticar. Contacte al administrador"
        );
      }
      setShowModal(true);
    }
  };

  const activeSendCodeToRestorePassword = (userData) => {
    handleIsChangePassword(false);
    handleIsRequiredPassword(true);
    handleIsReceiveCode(false);
    console.log("activeSendCodeToRestorePassword", userData);
    setDataFromSendCode(userData);
  };

  const handleCancelSendCode = () => {
    handleIsChangePassword(false);
    handleIsRequiredPassword(false);
    handleIsReceiveCode(false);
    setDataFromSendCode(null);
  };

  const handleOkReceiveCode = () => {
    handleIsChangePassword(false);
    handleIsRequiredPassword(false);
    handleIsReceiveCode(false);
  };

  const handleConfirmRequestCode = () => {
    handleIsChangePassword(false);
    handleIsRequiredPassword(false);
    handleIsReceiveCode(true);
  };
    
  const resetMessage = (sec) =>
    setTimeout(() => {
      resetAlert();
    }, sec * 1000);

  const resetAlert = () => {
    setShowAlert({
      show: false,
      title: "",
      message: "",
      type: "",
    });
  };

  return (
    <div className="login-wrapper d-flex-center">
      {showAlert.show && (
          <Alert
            title={showAlert.title}
            message={showAlert.message}
            type={showAlert.type}
            hasBg={true}
            position="top-right"
            handleClose={() => resetAlert()}
          />
      )}
      <div className="login-container d-flex-center">
        <div className="login-container__box text-center d-flex-center" style={{"backgroundImage": `url(${proveedores_jpg})`, "backgroundRepeat": "no-repeat","backgroundSize": "contain", "margin":"40px"}}>                     
          
        </div>
        <div className="login-container__box text-center margin-top-128px">
          <p className="title-04">Bienvenido a</p>
          <p className="title-04 title-red">
            <b>GESTION DE PROVEEDORES</b>
          </p>
          <div className="login-container__data d-flex-center">
            <div className="login-container__auth">
              <ButtonOAuth history={history}/>
            </div>                       
          </div>           
          {loading ? <Loading /> : null}
        </div>

        {showModal && (
          <Modal
            onLabelTextClosed="Text close"
            visible={showModal}
            width={544}
            onToggle={() => handleShowModal(!showModal)}
          >
            <p className="title-07">{messageModal}</p>
          </Modal>
        )}
      </div>
    </div>
  );
};

export default Login;
